import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const TeamSection = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamData = {
    title: "Nuestro Equipo Profesional",
    subtitle: "Our Professional Team",
    description: "Conoce a los expertos que hacen posible nuestro servicio excepcional. Cada miembro de nuestro equipo está capacitado y comprometido con la excelencia.",
    members: [
      {
        id: 1,
        name: "Carlos Rodríguez",
        position: "Fundador y Director General",
        positionEn: "Founder & General Manager",
        experience: "8+ años",
        specialization: "Gestión empresarial y desarrollo de servicios",
        description: `Carlos fundó BAC Pool CR con la visión de revolucionar el mantenimiento de piscinas en Costa Rica. Con más de 8 años de experiencia en el sector, ha liderado el crecimiento de la empresa desde sus inicios hasta convertirse en una referencia en el mercado costarricense.

Su enfoque en la innovación y la satisfacción del cliente ha sido fundamental para establecer los altos estándares de calidad que caracterizan a nuestra empresa.`,
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
        certifications: ["Gestión Empresarial", "Liderazgo de Equipos", "Desarrollo de Negocios"],
        languages: ["Español", "English"]
      },
      {
        id: 2,
        name: "María González",
        position: "Supervisora de Operaciones",
        positionEn: "Operations Supervisor",
        experience: "6+ años",
        specialization: "Coordinación de servicios y control de calidad",
        description: `María es responsable de coordinar todas las operaciones diarias y garantizar que cada servicio cumpla con nuestros estándares de excelencia. Su atención al detalle y capacidad organizativa aseguran que cada cliente reciba un servicio impecable.

Con amplia experiencia en gestión de equipos y procesos, María ha implementado sistemas de calidad que han mejorado significativamente la eficiencia operativa.`,
        image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
        certifications: ["Gestión de Operaciones", "Control de Calidad", "Atención al Cliente"],
        languages: ["Español", "English"]
      },
      {
        id: 3,
        name: "José Martínez",
        position: "Técnico Especialista Senior",
        positionEn: "Senior Pool Technician",
        experience: "7+ años",
        specialization: "Mantenimiento técnico y reparaciones especializadas",
        description: `José es nuestro técnico más experimentado, especializado en diagnósticos complejos y reparaciones avanzadas de sistemas de piscinas. Su conocimiento profundo de equipos y químicos lo convierte en el referente técnico del equipo.

Ha trabajado con todo tipo de piscinas, desde residenciales hasta comerciales, y su experiencia es invaluable para resolver los desafíos más complejos.`,
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
        certifications: ["Mantenimiento de Piscinas", "Manejo de Químicos", "Reparación de Equipos"],
        languages: ["Español", "English Básico"]
      },
      {
        id: 4,
        name: "Ana Vargas",
        position: "Especialista en Atención al Cliente",
        positionEn: "Customer Service Specialist",
        experience: "4+ años",
        specialization: "Comunicación con clientes y programación de servicios",
        description: `Ana es el primer punto de contacto para nuestros clientes y se encarga de coordinar todos los servicios. Su calidez y profesionalismo han sido clave para mantener la alta satisfacción de nuestros clientes.

Domina perfectamente tanto español como inglés, lo que le permite atender eficazmente a nuestra diversa base de clientes en Costa Rica.`,
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
        certifications: ["Atención al Cliente", "Comunicación Bilingüe", "Gestión de Citas"],
        languages: ["Español", "English Fluent"]
      }
    ]
  };

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
          {teamData.title}
        </h2>
        <p className="text-lg text-text-secondary font-medium mb-6">
          {teamData.subtitle}
        </p>
        <p className="max-w-3xl mx-auto text-text-secondary">
          {teamData.description}
        </p>
      </div>

      {/* Team Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {teamData.members.map((member) => (
          <div
            key={member.id}
            className="bg-surface rounded-lg overflow-hidden shadow-subtle hover:shadow-medium nav-transition cursor-pointer"
            onClick={() => setSelectedMember(member)}
          >
            <div className="aspect-[3/4] overflow-hidden">
              <Image
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover hover:scale-105 nav-transition"
              />
            </div>
            <div className="p-6">
              <h3 className="font-heading font-semibold text-text-primary mb-1">
                {member.name}
              </h3>
              <p className="text-sm text-primary font-medium mb-2">
                {member.position}
              </p>
              <p className="text-xs text-text-secondary mb-3">
                {member.specialization}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-mono bg-primary/10 text-primary px-2 py-1 rounded">
                  {member.experience}
                </span>
                <Icon name="ChevronRight" size={16} className="text-text-secondary" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Team Member Modal */}
      {selectedMember && (
        <div className="fixed inset-0 z-1100 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => setSelectedMember(null)}></div>
          <div className="relative bg-surface rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-start space-x-4">
                  <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0">
                    <Image
                      src={selectedMember.image}
                      alt={selectedMember.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl font-heading font-bold text-text-primary mb-1">
                      {selectedMember.name}
                    </h3>
                    <p className="text-primary font-medium mb-1">
                      {selectedMember.position}
                    </p>
                    <p className="text-sm text-text-secondary">
                      {selectedMember.positionEn}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setSelectedMember(null)}
                  className="p-2 rounded-md text-text-secondary hover:text-primary hover:bg-primary/5 nav-transition"
                >
                  <Icon name="X" size={20} />
                </button>
              </div>

              <div className="prose prose-lg max-w-none text-text-secondary mb-6">
                <p>{selectedMember.description}</p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-heading font-semibold text-text-primary mb-3">
                    Certificaciones
                  </h4>
                  <div className="space-y-2">
                    {selectedMember.certifications.map((cert, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Icon name="Award" size={16} className="text-accent" />
                        <span className="text-sm text-text-secondary">{cert}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="font-heading font-semibold text-text-primary mb-3">
                    Idiomas
                  </h4>
                  <div className="space-y-2">
                    {selectedMember.languages.map((lang, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <Icon name="Globe" size={16} className="text-primary" />
                        <span className="text-sm text-text-secondary">{lang}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TeamSection;